var indentation_default = {
  "indentZero": "Lbx1y",
  "indentOne": "mM3Fs",
  "indentTwo": "S8vhA",
  "indentThree": "TRMbb",
  "indentFour": "ySaZ1",
  "indentFive": "UM82e",
  "indentSix": "sMJi9"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation.scss.js.map
